import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

export interface TenantModel {
  createdAt: string;
  name: string;
  organizationId: string;
  tenantId: string;
  updatedAt: string;
  status?:
    | 'active'
    | 'failed'
    | 'in_progress'
    | 'delete_in_progress'
    | 'delete_failed';
}
export function useOrgTenants() {
  return useQuery({
    queryKey: ['listOrgTenants'],
    queryFn: () =>
      api.get<{ data: TenantModel[] }>(`/api/base/tenants`).then((res) => {
        return res.data.data;
      }),
    staleTime: 1000 * 60 * 2,
  });
}

export function useAddTenant() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ name }: { name: string }) =>
      api
        .post(`/api/base/tenant`, {
          name,
        })
        .then(() => {
          return queryClient.refetchQueries({ queryKey: ['listOrgTenants'] });
        }),
  });
}
export function useDefaultTenant() {
  return useQuery({
    queryKey: ['defaultTenant'],
    queryFn: () => {
      return localStorage.getItem('defaultTenant');
    },
  });
}

export function useUpdateDefaultTenant() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (tenantId: string) => {
      localStorage.setItem('defaultTenant', tenantId);
      await queryClient.refetchQueries({ queryKey: ['defaultTenant'] });
    },
  });
}
